<ol class="breadcrumb" *ngIf="crumbs.length">
  <li *ngFor="let crumb of crumbs; let last = last" class="breadcrumb-item" [class.active]="last">
    <span *ngIf="last; else link">{{ crumb.text }}</span>
    <ng-template #link>
      <a class="breadcrumb-link" [routerLink]="crumb.path">
        {{ crumb.text }}
      </a>
    </ng-template>
  </li>
</ol>
